export class UriViewModel {
  value: string;
  url: string;

  constructor(data: { value: string; url: string }) {
    this.value = data.value;
    this.url = data.url;
  }
}
